<template>
  <div class="content">
    <div class="u-success">
      <img :src="extraItem.extras('rejectResult.src')" alt="" />
    </div>
    <div
      class="t-success-new"
      v-if="extras.rejectResult.text != 'hide'"
      :style="{
        color:
          extras.successResult.text == 'custom'
            ? extras.successResult.fontColor
            : '',
        'font-size':
          platform != 'wap' && extras.successResult.text == 'custom'
            ? extras.successResult.fontSize + 'px'
            : '',
        'font-style':
          extras.successResult.text == 'custom'
            ? extras.successResult.fontTilt == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          extras.successResult.text == 'custom'
            ? extras.successResult.fontWeight == 'on'
              ? 'bolder'
              : ''
            : '',
      }"
    >
      {{ extras | extra("rejectResult.content") }}
    </div>
    <div
      class="t-success-desc-new"
      v-if="extras.rejectResult.text2 != 'hide'"
      :style="{
        color:
          extras.successResult.text2 == 'custom'
            ? extras.successResult.fontColor2
            : '',
        'font-size':
          platform != 'wap' && extras.successResult.text2 == 'custom'
            ? extras.successResult.fontSize2 + 'px'
            : '',
        'font-style':
          extras.successResult.text2 == 'custom'
            ? extras.successResult.fontTilt2 == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          extras.successResult.text2 == 'custom'
            ? extras.successResult.fontWeight2 == 'on'
              ? 'bolder'
              : ''
            : '',
      }"
    >
      {{ extras | extra("rejectResult.content2") }}
    </div>
  </div>
</template>
<script>
export default {
  name: "RefuseCon",
  props: ["platform"],
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
};
</script>
